import { IconProps } from '@chakra-ui/icons';
import { Icon } from '@chakra-ui/react';

import colors from '../../../themes/default-theme/colors';

type AdditionalProps = {
    fill?: string;
};

export const DocumentIcon = (props: IconProps & AdditionalProps) => {
    const { fill = colors.brand.main, ...rest } = props;

    return (
        <Icon viewBox="0 0 14 17" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.41667 1.5C2.17355 1.5 1.94039 1.59658 1.76849 1.76849C1.59658 1.94039 1.5 2.17355 1.5 2.41667V14.0833C1.5 14.3264 1.59658 14.5596 1.76849 14.7315C1.94039 14.9034 2.17355 15 2.41667 15H10.75C10.9931 15 11.2263 14.9034 11.3982 14.7315C11.5701 14.5596 11.6667 14.3264 11.6667 14.0833V5.22733L7.93934 1.5H2.41667ZM0.707825 0.707825C1.16104 0.254612 1.77573 0 2.41667 0H8.25C8.44891 0 8.63968 0.0790176 8.78033 0.21967L12.947 4.38634C13.0876 4.52699 13.1667 4.71775 13.1667 4.91667V14.0833C13.1667 14.7243 12.9121 15.339 12.4588 15.7922C12.0056 16.2454 11.3909 16.5 10.75 16.5H2.41667C1.77573 16.5 1.16104 16.2454 0.707825 15.7922C0.254612 15.339 0 14.7243 0 14.0833V2.41667C0 1.77573 0.254612 1.16104 0.707825 0.707825Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75 0C8.16421 0 8.5 0.335786 8.5 0.75V4.08333C8.5 4.10543 8.50878 4.12663 8.52441 4.14226C8.54004 4.15789 8.56123 4.16667 8.58333 4.16667H11.9167C12.3309 4.16667 12.6667 4.50245 12.6667 4.91667C12.6667 5.33088 12.3309 5.66667 11.9167 5.66667H8.58333C8.16341 5.66667 7.76068 5.49985 7.46375 5.20292C7.16682 4.90599 7 4.50326 7 4.08333V0.75C7 0.335786 7.33579 0 7.75 0Z"
                fill={fill}
            />
        </Icon>
    );
};
